module.exports = __webpack_public_path__ + "img/s.c1e18d26.jpg";